<app-screen-loader
  [visible]="reportDownloadLoader"
  [message]="'ACCOUNT.REPORT_DOWNLOADING' | translate"
></app-screen-loader>

@if (loader) {
  <app-skeleton-loader
    [formLoader]="true"
    [noOfFields]="8"
  ></app-skeleton-loader>
}
@if (!loader) {
  <!-- Header bar -->
  @if (isPlatinumMember) {
    <div class="flex flex-col gap-6 lg:grid lg:grid-cols-2 lg:gap-6 mt-4 mb-4">
      <!-- LEFT CARD -->
      <div class="border border-gray-200 bg-white p-4 shadow-sm w-full">
        <h1 class="text-2xl font-bold mb-2 text-dc-navy">
          {{
            lang == "en"
              ? membership?.["DC Name English"]
              : membership?.["DC Name Arabic"]
          }}
        </h1>

        <div class="flex flex-wrap items-center gap-3">
          <!-- @if (isLicenseActive(membership)) {
      <span class="dc-status dc-status-active p-2!">
        {{ "ACCOUNT.LICENSE_ACTIVE" | translate }}
      </span>
      } @else {
      <span class="dc-status dc-status-inactive p-2!">
        {{ "MEM.LICENSE_EXPIRED" | translate }}
      </span>
      } -->

          <span
            class="dc-status p-2!"
            [ngClass]="{
              'dc-status-cancelled':
                getMemberDisplayStatus(membership) === 'Inactive' ||
                getMemberDisplayStatus(membership) === 'Cancelled',
              'dc-status-negative': getMemberDisplayStatus(membership) === 'Expired',
              'dc-status-warning':
                getMemberDisplayStatus(membership) === 'Active - Renew',
              'dc-status-active':
                getMemberDisplayStatus(membership) !== 'Expired' &&
                getMemberDisplayStatus(membership) !== 'Inactive' &&
                getMemberDisplayStatus(membership) !== 'Cancelled' &&
                getMemberDisplayStatus(membership) !== 'Active - Renew'
            }"
          >
            {{
              "ACCOUNT.LICENSE_ACTIVE"
                | translate: { licenseStatus: getMemberDisplayStatus(membership) }
            }}
          </span>

          <span>
            <img src="/images/platinum-badge.png" />
          </span>
        </div>
      </div>

      <!-- RIGHT CARD -->
      <div class="border border-gray-200 bg-white p-4 shadow-sm w-full">
        <div
          class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"
        >
          <div class="flex items-center gap-6">
            <img
              [src]="'/icons/platinum/user.svg'"
              class="h-16 w-16 rounded-full object-cover ring-1 ring-dc-sky-50"
              [alt]="membership?.['DC First POC Manager']"
            />
            <div>
              <h1 class="text-2xl font-bold mb-2 text-dc-navy">
                {{ membership?.["DC First POC Manager"] }}
              </h1>
              <p class="text-base! font-light! text-dc-navy!">
                {{ membership?.["DC First POC Title"] }}
              </p>
              <p class="text-base! font-light! text-dc-navy!">
                {{ membership?.["DC First POC Email Addr"] }}
              </p>
            </div>
          </div>

          <app-button
            [label]="'BUTTONS.EMAIL' | translate"
            classesName="card-edge-cut-white text-dc-navy"
            (onBtnClick)="emailRelationshipManager()"
          >
          </app-button>
        </div>
      </div>
    </div>
  }

  <div class="bg-white p-5">
    @if (!isPlatinumMember) {
      <h1 class="text-2xl font-bold mb-2 text-dc-navy">
        {{
          lang == "en"
            ? membership?.["DC Name English"]
            : membership?.["DC Name Arabic"]
        }}
      </h1>
      <span
        class="dc-status p-2!"
        [ngClass]="{
          'dc-status-negative':
            getMemberDisplayStatus(membership) === 'Expired' ||
            getMemberDisplayStatus(membership) === 'Inactive' ||
            getMemberDisplayStatus(membership) === 'Cancelled',
          'dc-status-warning':
            getMemberDisplayStatus(membership) === 'Active - Renew',
          'dc-status-active':
            getMemberDisplayStatus(membership) !== 'Expired' &&
            getMemberDisplayStatus(membership) !== 'Inactive' &&
            getMemberDisplayStatus(membership) !== 'Cancelled' &&
            getMemberDisplayStatus(membership) !== 'Active - Renew'
        }"
      >
        {{
          "ACCOUNT.LICENSE_ACTIVE"
            | translate: { licenseStatus: getMemberDisplayStatus(membership) }
        }}
      </span>
    }

    <!-- company complete information notice -->
    <!-- @if(flags.accountManagementEnabled){
    <div class="lg:w-[30%]">
        <app-validation-message
          [type]="'warning'"
          [content]="{
            title: 'ACCOUNT.COMPLETE_INFO_TITLE' | translate : { days: 15 },
            message: 'ACCOUNT.COMPLETE_INFO_MSG' | translate
          }"
          [showCloseIcon]="false"
          [showbutton]="false"
        ></app-validation-message>
        <div class="mt-5">
          <app-button
            [label]="'BUTTONS.COMPLETE_COMPANY_INFORMATION' | translate"
            [classesName]="'btn-edge-cut'"
            (onBtnClick)="gotoCompanyPage()"
          ></app-button>
        </div>
      </div>
    } -->
    <!-- End -->

    <!-- access request card -->
    @if (
      pendingAccessRequest && pendingAccessRequest.length > 0 && isPrimaryUser
    ) {
      @if (!isPlatinumMember) {
        <hr class="my-2 text-gray-300" />
      }
      <div class="lg:w-[30%]">
        @for (userReq of pendingAccessRequest; track $index) {
          <app-validation-message
            [type]="'info'"
            [content]="{
              title: 'ACCOUNT.ACCESS_REQUEST.TITLE' | translate,
              message:
                ('ACCOUNT.ACCESS_REQUEST.TEXT'
                | translate
                  : {
                      name: `${userReq['Created First Name']} ${userReq['Created Last Name']}`,
                      roles: this.userRoles(userReq),
                    }),
            }"
            [showTypeIcon]="true"
            [showCloseIcon]="false"
            [showbutton]="false"
            [buttonText]="'ACCOUNT.ACCESS_REQUEST.VIEW' | translate"
            (onBtnClick)="gotoRequest(userReq)"
            (closed)="showAddBusinessMessage = false"
          >
          </app-validation-message>

          <!-- action buttons -->
          <div class="flex flex-wrap gap-3 mt-2">
            <app-button
              [label]="'ACCOUNT.ACTIONS.APPROVE' | translate"
              classesName="btn-edge-cut"
              (onBtnClick)="approveRejectRequest('approve', userReq)"
            >
            </app-button>

            <app-button
              [label]="'ACCOUNT.ACTIONS.REJECT' | translate"
              classesName="card-edge-cut-white"
              (onBtnClick)="approveRejectRequest('reject', userReq)"
            >
            </app-button>
          </div>
        }
      </div>
    }
    <!-- Buttons for download certificate and apply services -->
    @if (flags.accountManagementEnabled) {
      @if (pendingAccessRequest.length > 0 || !isPlatinumMember) {
        <hr class="my-6 text-gray-300" />
      }
      <div class="flex flex-wrap gap-3 mt-2">
        <app-button
          [label]="'ACCOUNT.ACTIONS.CERTIFICATE' | translate"
          classesName="text-dc-navy btn-primary-big"
          (onBtnClick)="downloadCert()"
        >
        </app-button>
        <app-button
          [label]="'ACCOUNT.ACTIONS.MANAGE_USERS' | translate"
          classesName="card-edge-cut-white text-dc-navy btn-primary-big"
          (onBtnClick)="manageUsers()"
        >
        </app-button>

        <app-button
          [label]="'ACCOUNT.ACTIONS.APPLY_SERVICE' | translate"
          classesName="card-edge-cut-white text-dc-navy btn-primary-big"
          (onBtnClick)="applyService()"
        >
        </app-button>
      </div>
    }
  </div>

  <!-- Tabs -->
  <div class="mt-10 border border-gray-100 bg-white">
    <ul
      class="hidden lg:flex overflow-x-auto scrollbar-hide text-dc-blackborder-t border-gray-200 cursor-pointer bg-[#00386533] rounded-t-lg"
    >
      @for (t of tabs; track t) {
        <li
          class="px-4 py-4 mx-6 cursor-pointer text-base font-medium"
          [class.active-tab-item]="tab === t"
          (click)="setActiveTab(t)"
        >
          {{ "ACCOUNT.TABS." + t.toUpperCase() | translate }}
        </li>
      }
    </ul>

    <!-- Drop-down (mobile) -->
    <div
      class="lg:hidden block border-t border-gray-200 cursor-pointer bg-[#00386533] rounded-t-lg"
    >
      <select
        class="w-full bg-transparent px-4 py-3 text-base text-dc-navy font-semibold focus:outline-none"
        name="tabs"
        [ngModel]="tab"
        (ngModelChange)="setActiveTab($event)"
      >
        @for (mt of tabs; track mt) {
          <option [value]="mt">
            {{ "ACCOUNT.TABS." + mt.toUpperCase() | translate }}
          </option>
        }
      </select>
    </div>

    <!-- Tab content – child components -->
    <div class="p-5">
      @if (tab === "overview") {
        <app-membership-overview [details]="membership">
        </app-membership-overview>
        @if (isPrimaryUser) {
          <div class="mt-6">
            <app-button
              type="button"
              [label]="'ACCOUNT.MEMBERSHIP.UPDATE' | translate"
              classesName="card-edge-cut-white text-dc-navy"
              (onBtnClick)="updateMembership()"
            >
            </app-button>
          </div>
        }
      }
      @if (tab === "owners") {
        <app-membership-owners
          [owners]="ownerList"
          [documents]="this.srFolder"
        ></app-membership-owners>
      }
      @if (tab === "activities") {
        <app-membership-activities
          [activities]="licenseActivities"
        ></app-membership-activities>
      }
      @if (tab === "users") {
        <app-membership-users
          [users]="linkedUsers"
          [loader]="userLoader"
          (unlinkUser)="unLinkUser($event)"
          [isPrimaryUser]="isPrimaryUser"
          [memberNumber]="memberNumber"
        ></app-membership-users>
      }
      @if (tab === "you") {
        <app-membership-you
          [userDetail]="loginUser"
          [userAccessData]="userAccessData"
          [accessableServices]="accessableServices"
          [contacts]="linkedUsers"
          (unlinkUser)="unlinkMySelf()"
        >
        </app-membership-you>
      }
      @if (tab === "platinum") {
        <div class="bg-white">
          <h2 class="text-lg font-semibold mb-4 text-dc-navy">
            {{ "ACCOUNT.PLATINUM_MEMBERSHIP" | translate }}
          </h2>
          <table class="dc-table dc-table-list">
            <tbody>
              <tr>
                <td class="py-4!">
                  {{ "ACCOUNT.PLATINUM_MEMBERSHIP_DURATION" | translate }}
                </td>
                <td class="py-4!">
                  {{ "ACCOUNT.PLATINUM_MEMBERSHIP_FIVE_YEARS" | translate }}
                </td>
              </tr>
            </tbody>
          </table>
          <div class="mt-6 mb-6">
            <p>{{ "ACCOUNT.PLATINUM_MEMBERSHIP_REPORT" | translate }}</p>
          </div>
          <div class="flex flex-wrap gap-3 mt-2">
            <app-button
              [label]="'BUTTONS.DOWNLOAD_REPORT' | translate"
              [classesName]="'card-edge-cut-white btn-primary-big'"
              (onBtnClick)="downloadPlatinumReport()"
            ></app-button>
             <app-button
              [label]="'BUTTONS.VIEW_REPORT' | translate"
              [classesName]="'card-edge-cut-white btn-primary-big'"
              (onBtnClick)="viewPlatinumReport()"
            ></app-button>
          </div>

          @if (viewReportLoader) {
            <div class="mt-6 p-2 text-center">
              <span class="text-dc-navy text-base">
                {{ "LOADING" | translate }}
              </span>
            </div>
          }

          @if (showPowerBiReport) {
            <div
              class="mt-6 border border-gray-200 bg-white p-4 power-bi-report-shell"
              [class.power-bi-report-shell-fullscreen]="isPowerBiFullscreen"
            >
              <div class="mb-4 flex justify-end">
                <app-button
                  [label]="
                    (isPowerBiFullscreen
                      ? 'BUTTONS.MINIMIZE_SCREEN'
                      : 'BUTTONS.FULL_SCREEN') | translate
                  "
                  [iconClass]="
                    isPowerBiFullscreen ? 'fas fa-compress' : 'fas fa-expand'
                  "
                  [classesName]="'card-edge-cut-white text-dc-navy'"
                  (onBtnClick)="togglePowerBiFullscreen()"
                ></app-button>
              </div>
              <div
                #powerBiContainer
                class="w-full min-h-[100px] power-bi-report-container"
              ></div>
            </div>
          }
        </div>
      }
    </div>
  </div>

  @if (showUnlinkConfirmation) {
    <app-confirmation-modal
      [title]="'CONFIRMATION_TITLE'"
      [message]="
        isDelinkYourself ? 'DELINK_YOURSELF_MESSAGE' : 'REMOVE_USER_MESSAGE'
      "
      [confirmLabel]="'BUTTONS.OK'"
      [cancelLabel]="'BUTTONS.CANCEL'"
      [loading]="unlinkUserLoader"
      (confirm)="confirmUnLinkUser()"
      (cancel)="closeUnlinkConfirmation()"
    ></app-confirmation-modal>
  }

  @if (showApproveAccessConfirmation) {
    <app-confirmation-modal
      [message]="'ACCOUNT.ACCESS_REQUEST.UPDATE_SERVICE_ACCESS_MESSAGE'"
      [confirmLabel]="'BUTTONS.OK'"
      [showCancel]="false"
      (confirm)="confirmApproveAccessConfirmation()"
      (cancel)="closeApproveAccessConfirmation()"
    ></app-confirmation-modal>
  }

  @if (showReportFilterModal) {
    <div class="dc-modal">
      <div
        class="dc-modal-container bg-white w-[calc(100vw-32px)]! max-w-[620px]! min-w-0! overflow-visible!"
      >
        <div class="px-2">
          <h2 class="text-xl font-semibold text-dc-navy mb-6">
            {{ "ACCOUNT.SELECT_DATE_RANGE" | translate }}
          </h2>

          <div class="space-y-2">
            <div class="mt-1 flex flex-col gap-3 sm:flex-row">
              <div class="relative flex-1 min-w-0">
                <input
                  type="text"
                  class="calendar-field w-full"
                  [placeholder]="'PAYMENTS.FILTER.DATE_FROM' | translate"
                  [value]="dateFromDisplay"
                  readonly
                  (click)="toggleDateCalendar('from')"
                />
                <button
                  type="button"
                  class="calendar-field-icon"
                  (click)="toggleDateCalendar('from')"
                >
                  <i class="fas fa-calendar"></i>
                </button>
                @if (dateFromDisplay) {
                  <button
                    type="button"
                    class="calendar-field-clear"
                    (click)="clearDateFrom($event)"
                    aria-label="Clear date from"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                }
                @if (showDateFromCalendar) {
                  <div class="absolute z-[70] mt-2">
                    <app-inline-calendar
                      [selected]="selectedDateFrom || today"
                      [disablePast]="false"
                      [disableFuture]="true"
                      (onDatePicked)="onDateFromPicked($event)"
                    ></app-inline-calendar>
                  </div>
                }
              </div>
              <div class="relative flex-1 min-w-0">
                <input
                  type="text"
                  class="calendar-field w-full"
                  [placeholder]="'PAYMENTS.FILTER.DATE_TO' | translate"
                  [value]="dateToDisplay"
                  readonly
                  (click)="toggleDateCalendar('to')"
                />
                <button
                  type="button"
                  class="calendar-field-icon"
                  (click)="toggleDateCalendar('to')"
                >
                  <i class="fas fa-calendar"></i>
                </button>
                @if (dateToDisplay) {
                  <button
                    type="button"
                    class="calendar-field-clear"
                    (click)="clearDateTo($event)"
                    aria-label="Clear date to"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                }
                @if (showDateToCalendar) {
                  <div class="absolute z-[70] mt-2">
                    <app-inline-calendar
                      [selected]="selectedDateTo || today"
                      [disablePast]="false"
                      [disableFuture]="true"
                      [minDate]="selectedDateFrom"
                      (onDatePicked)="onDateToPicked($event)"
                    ></app-inline-calendar>
                  </div>
                }
              </div>
            </div>

            @if (reportDateRequiredError) {
              <div class="fields-error-container">
                <div>{{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}</div>
              </div>
            }

            @if (reportDateRangeError) {
              <div class="fields-error-container">
                <div>{{ "VALIDATION_MSG.DATE_TO_AFTER_FROM" | translate }}</div>
              </div>
            }

            <div class="flex flex-wrap gap-3 pt-2">
              <app-button
                [label]="'BUTTONS.CANCEL' | translate"
                classesName="card-edge-cut-white text-dc-navy"
                (onBtnClick)="closeReportFilterModal()"
              ></app-button>
              <app-button
                [label]="'BUTTONS.SUBMIT' | translate"
                classesName="btn-edge-cut"
                (onBtnClick)="submitPlatinumReport()"
              ></app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

